
const Navigation = {
  methods: {
    urlFor (item) {
      const location = this.$route.params.location ||this.$route?.meta?.location;
      const prefix = location ? `/${location}/` : '/';
      if (item.link.linkType === 'Document') {
        return `${prefix}${item.link.uid}`;
      } else if (item.link.linkType === 'Web' || item.link.linkType === 'Media') {
        const url = item.link.url;
        return url.match('#') ? '#' + url.split('#')[1] : url;
      }
    },

    actionFor (item) {
      const url = this.urlFor(item);
      if (item.link.linkType === 'Document') {
        this.navigate('page', item.link.uid);
      } else if (item.link.linkType === 'Media') {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  }

};

export default Navigation;
